function LocationHeader() {
  return (
    <div className="locationHeaderBox">
      <div className="locationTextBox">
        <h1 className="lHText">Locations</h1>
      </div>
    </div>
  );
}
export default LocationHeader;
